import React from 'react';

const Column = ({ className, children }) => {
  return <div className={`form-group-column ${className}`}>{children}</div>;
};

export default Column;
